import Vue from "vue";
import VueRouter from "vue-router"
import appContent from "./component/content"

import defines from "./views/defines"
import anasayfa from "./views/home"
//import anasayfa from "./views/home"
import Cihaz from "./views/cihaz/Cihaz"
import cihazekle from "./views/cihaz/create"
import cihazupdate from "./views/cihaz/update"
import grafikcihaz from "./views/cihaz/cihazgrafik"
import detaycihaz from "./views/cihaz/detay"
import raporcihaz from "./views/cihaz/rapor"

import servisekle from "./views/servis/create"
import servisekle1 from "./views/servis/createcihazdan"
import servisekle2 from "./views/servis/createcariden"

import bekleyenservis from "./views/servis/bekleyen"
import yonlenenservis from "./views/servis/yonlenen"
import devamedenservis from "./views/servis/devameden"
import tamamlananservis from "./views/servis/tamamlanan"
import plan from "./views/servis/plan"
import servisdetay from "./views/servis/detay"
import servisrapor from "./views/servis/rapor"

import cari from "./views/cari/cari"
import detaycari from "./views/cari/detay"
import raporcari from "./views/cari/rapor"

import kullanici from "./views/kullanici/liste"
import kullaniciekle from "./views/kullanici/create"
import kullaniciduzen from "./views/kullanici/duzen"
import kullanicidetay from "./views/kullanici/detay"

import ekip from "./views/kullanici/ekip"
import ekipdetay from "./views/kullanici/ekipdetay"

import LoginPage from './login/LoginPage'
//import LoginPage from './views/login'
import teklif from './views/func/teklif'
import aktarim from './views/aktarim'
import envarter from './views/envarter'
import gruplama from './views/cihaz/altgrup'
import duzenaltgrup from './views/cihaz/duzenaltgrup'
//import token from './views/token'
//aktarım klasörü
import cariaktarim from './views/aktarim/cari'
import googlemap from './views/googlemap'
import malzeme from './views/malzemeRapor'
//aktarım klasörü
Vue.use(VueRouter);
const routes = [
  { path: '/login', component: LoginPage },
  {
    path: '/',
    component: appContent,
    redirect: '/anasayfa',
    children: [
      {
        path: "/anasayfa",
        component: anasayfa,
        Name: "Anasayfa"
      },
      { path: '/teklif/:id', component: teklif },
      { path: '/envarter', component: envarter },
      { path: '/gruplama/:table', component: gruplama },
      { path: '/googlemap', component: googlemap },
      { path: '/malzemerapor', component: malzeme },



      // otherwise redirect to home
      //{ path: '*', redirect: '/' },
      {
        path: "/defines/:table",
        component: defines,
        Name: "Sistem Tanımlamaları"
      },
      {
        path: "/liste/cihaz",
        component: Cihaz,
        Name: "Cihaz Sayfası"
      },
      {
        path: "/liste/cari",
        component: cari,
        Name: "Cari Sayfası"
      },
      {
        path: "/create/cihaz",
        component: cihazekle,
        Name: "Cihaz Ekle"
      },
      {
        path: "/update/cihaz/:id",
        component: cihazupdate,
        Name: "Cihaz Bilgi Güncelle"
      },
      {
        path: "/grafik/:cihaz",
        component: grafikcihaz,
        Name: "Sayısal Cihaz"
      },
      {
        path: "/detay/cihaz/:id",
        component: detaycihaz,
        Name: "Cihaz Detay Sayfası"
      },
      {
        path: "/detay/cari/:kod",
        component: detaycari,
        Name: "Cari Detay Sayfası"
      },
      {
        path: "/rapor/cari/:kod",
        component: raporcari,
        Name: "Rapor Detay Rapor Sayfası"
      },
      {
        path: "/rapor/cihaz/:id",
        component: raporcihaz,
        Name: "Cihaz Detay Rapor Sayfası"
      },
      {
        path: "/servis/plan/:id",
        component: plan,
        Name: "Servis Palanlama"
      },
      {
        path: "/detay/servis/:id",
        component: servisdetay,
        Name: "Servis Detay Sayfası"
      },
      {
        path: "/create/servis",
        component: servisekle,
        Name: "Servis Ekle"
      },
      {
        path: "/create/servis/cihaz/:guid",
        component: servisekle1,
        Name: "Servis Ekle"
      },
      {
        path: "/create/servis/cari/:guid",
        component: servisekle2,
        Name: "Servis Ekle"
      },
      {
        path: "/liste/servis/bekleyen",
        component: bekleyenservis,
        Name: "Bekleyen Servis"
      },
      {
        path: "/liste/servis/yonlendirilen",
        component: yonlenenservis,
        Name: "Yönlendirilen Servis"
      },
      {
        path: "/liste/servis/devameden",
        component: devamedenservis,
        Name: "Devam eden servis"
      },
      {
        path: "/liste/servis/tamamlanan",
        component: tamamlananservis,
        Name: "Tamamlanan servis"
      },
      {
        path: "/liste/kullanici",
        component: kullanici,
        Name: "Kullancı Listesi"
      },
      {
        path: "/detay/kullanici/:id",
        component: kullanicidetay,
        Name: "Kullancı Yetkilendirme"
      },
      {
        path: "/duzen/kullanici/:id",
        component: kullaniciduzen,
        Name: "Kullancı Düzenleme"
      },
      {
        path: "/create/kullanici",
        component: kullaniciekle,
        Name: "Kullancı Ekle"
      },
      {
        path: "/create/ekip",
        component: ekip,
        Name: "Ekip Ekle"
      },
      {
        path: "/detay/ekip/:id",
        component: ekipdetay,
        Name: "Ekip Detay"
      },
      {
        path: "/rapor/servis",
        component: servisrapor,
        Name: "Rapor Servis"
      },
      { path: '/aktarim', component: aktarim },
      { path: '/duzen/altgrup/:id', component: duzenaltgrup },
      //aktarım klasörü
      { path: '/cariaktarim', component: cariaktarim },
      //aktarım klasörü
    ]
  }
];
export const router = new VueRouter({
  //	mode: "history",
  routes
}); router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = ['/login'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('tfx');
  if (authRequired && !loggedIn) {

    return next({
      path: '/login',
      query: { returnUrl: to.path }
    });
  }

  next();
})


// WEBPACK FOOTER //
// ./src/router.js